import firestore from "../firebase/firestore";

export const getPowerPlant = (power_plant_id) => {
  return firestore.doc(`power_plants/${power_plant_id}`).get();
};

export const getPowerPlants = (args) => {
  let ref = firestore.collection("power_plants");
  if (args && args.searchBy) {
    ref = ref.where(
      args.searchBy.field,
      args.searchBy.operator,
      args.searchBy.value,
    );
    if (args.searchBy.operator !== "==")
      ref = ref.orderBy(args.searchBy.field, "asc");
  } else if (args && args.orderBy) {
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  } else if (args && args.orderBy) {
    // console.log('field: ', args.orderBy.field)
    // console.log('direction: ', args.orderBy.direction)
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  }
  if (args && args.limit && args.page) {
    ref = ref.limit(args.limit);
    ref = ref.offset(args.page * args.limit - args.limit);
  }

  return ref.get();
};
